import { render } from "./logout.html?vue&type=template&id=726fc588&ts=true&external"
import script from "./logout.ts?vue&type=script&lang=ts&external"
export * from "./logout.ts?vue&type=script&lang=ts&external"

import "./logout.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__